<template>
  <fieldset>
    <p>För mer instruktioner om hur du tar fram dessa inställningar, se <a href="https://docs.dintero.com/docs/integrations/checkout-prereq">Dinteros dokumentation.</a></p>
    <p>OBS! Det är ej lämpligt att koppla fler än en integration av denna typ till en profil.</p>
    <div class="input-group mb-3">
      <div class="input-group-prepend">
        <div class="input-group-text">ClientId</div>
      </div>
      <input type="text" class="form-control" required v-model="clientId" @input="onUpdate">
    </div>

    <div class="input-group mb-3">
      <div class="input-group-prepend">
        <div class="input-group-text">ClientSecret</div>
      </div>
      <input type="text" class="form-control" required v-model="clientSecret" @input="onUpdate">
    </div>

    <div class="input-group mb-3">
      <div class="input-group-prepend">
        <div class="input-group-text">AccountId</div>
      </div>
      <input type="text" class="form-control" required v-model="accountId" @input="onUpdate">
    </div>

    <div class="input-group mb-3">
      <div class="input-group-prepend">
        <div class="input-group-text">ProfileId</div>
      </div>
      <input type="text" class="form-control" required v-model="profileId" @input="onUpdate">
    </div>
  </fieldset>
</template>

<script setup lang="ts">
import { computed, ref, watch } from "vue";
const props = defineProps({
  modelValue: {
    type: Object,
    default: undefined
  }
});
const currentValue = computed(() => props.modelValue ?? {});
const emit = defineEmits(["update:modelValue"]);
const clientId = ref(null);
const clientSecret = ref(null);
const accountId = ref(null);
const profileId = ref(null);
const serializedValue = computed(() => {
  return {
    client_id: clientId.value,
    client_secret: clientSecret.value,
    account_id: accountId.value,
    profile_id: profileId.value
  };
});
function onUpdate() {
  emit("update:modelValue", serializedValue.value);
}
watch(currentValue, () => {
  if (JSON.stringify(currentValue.value) !== JSON.stringify(serializedValue.value)) {
    clientId.value = currentValue.value.client_id;
    clientSecret.value = currentValue.value.client_secret;
    accountId.value = currentValue.value.account_id;
    profileId.value = currentValue.value.profile_id;
  }
}, {
  immediate: true
});
</script>
